<template>
    <div v-if="visible" class="popup-overlay" @click.self="closePopup">
      <div class="popup-content">
        <button class="close-button" @click="closePopup">×</button>
        <slot>
			{{ $t('Popup.PopupContent') }}
		</slot>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      visible: {
        type: Boolean,
        required: true,
      },
    },
    emits: ['close'],
    methods: {
      closePopup() {
        this.$emit('close');
      },
    },
  };
  </script>
  
  <style>
  .popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999999999;
  }
  
  .popup-content {
    background: url('https://snippcheck.blob.core.windows.net/files/WK_Kellogg_Free_Beach_Towel_2007813/images/FooterMobile_BG.png') center center no-repeat;
    padding: 30px 20px;
    border-radius: 0px;
	border: 5px solid #fff;
    max-width: 420px;
    width: 90%;
    text-align: center;
    position: relative;
  }
  
  .close-button {
    position: absolute;
    top: 2px;
    right: 5px;
    background: none;
    border: none;
    font-size: 30px;
    cursor: pointer;
  }
  </style>
  